
export const TARIFF_FEATURE_SCOPES = {
    QUIZ: 'quiz',
    SERVICE: 'service',
    USER: 'user',
}

export const TARIFF_FEATURE_KEYS = {
    QUIZ_LOGIC: 'quiz.logic',
    QUIZ_RESULT_PAGE: 'quiz.result_page',
    QUIZ_POINTS: 'quiz.points',
    QUIZ_FILE_UPLOAD: 'quiz.file_upload',
    QUIZ_HIDE_ADSQUIZ_LOGO: 'quiz.hide_adsquiz_logo',
    QUIZ_CUSTOM_DOMAIN: 'quiz.custom_domain',
    QUIZ_FAVICON: 'quiz.favicon',
    QUIZ_SITE_INSTALL: 'quiz.site_install',
    QUIZ_REDIRECT: 'quiz.redirect',
    QUIZ_UTM_TRACKING: 'quiz.utm_tracking',
    SERVICE_CRM: 'service.crm',
    SERVICE_ANALYTICS: 'service.analytics',
    SERVICE_AI_BUILDER: 'service.ai_builder',
    USER_STORAGE_QUOTA: 'user.storage_quota',
    USER_PROJECTS: 'user.projects',
    USER_TEAM: 'user.team',
}

export const TARIFF_DOWNGRADE_POLICIES = {
    [TARIFF_FEATURE_KEYS.QUIZ_LOGIC]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.QUIZ_RESULT_PAGE]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.QUIZ_POINTS]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.QUIZ_FILE_UPLOAD]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.QUIZ_HIDE_ADSQUIZ_LOGO]: 'watermark',
    [TARIFF_FEATURE_KEYS.QUIZ_CUSTOM_DOMAIN]: 'quantitative',
    [TARIFF_FEATURE_KEYS.QUIZ_SITE_INSTALL]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.QUIZ_REDIRECT]: 'grandfathered',
    [TARIFF_FEATURE_KEYS.USER_TEAM]: 'quantitative',
}

export const DEFAULT_TARIFF_DOWNGRADE_POLICY = 'strict'

export const TARIFF_GATE_STATES = {
    ALLOWED: 'allowed',
    UNAVAILABLE: 'unavailable',
    QUOTA_EXHAUSTED: 'quota-exhausted',
    USAGE_UNAVAILABLE: 'usage-unavailable',
    GRANDFATHERED: 'grandfathered',
    READ_ONLY: 'read-only',
    DELETE_ONLY: 'delete-only',
    COLLABORATION_FORBIDDEN: 'collaboration-forbidden',
    UNKNOWN: 'unknown',
    LOADING: 'loading',
}

export const TARIFF_GATE_ACTIONS = {
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    COPY: 'copy',
    PUBLISH: 'publish',
}

export const TARIFF_GATE_REASON_CODES = {
    TARIFF_FEATURE_UNAVAILABLE: 'TARIFF_FEATURE_UNAVAILABLE',
    TARIFF_FEATURE_QUOTA_EXHAUSTED: 'TARIFF_FEATURE_QUOTA_EXHAUSTED',
    TARIFF_FEATURE_USAGE_UNAVAILABLE: 'TARIFF_FEATURE_USAGE_UNAVAILABLE',
    TARIFF_FEATURE_GRANDFATHERED: 'TARIFF_FEATURE_GRANDFATHERED',
    TARIFF_FEATURE_UNKNOWN: 'TARIFF_FEATURE_UNKNOWN',
    TARIFF_ACCESS_LOADING: 'TARIFF_ACCESS_LOADING',
    COLLABORATION_PERMISSION_DENIED: 'COLLABORATION_PERMISSION_DENIED',
    ALLOWED: 'ALLOWED',
}

export const TARIFF_ACCESS_LIFECYCLE = {
    IDLE: 'idle',
    LOADING: 'loading',
    READY: 'ready',
    REFRESHING: 'refreshing',
    ERROR: 'error',
    UNKNOWN: 'unknown',
}

export function getFeatureScope(lookupKey) {
    if (typeof lookupKey !== 'string' || !lookupKey.includes('.')) {
        return null
    }

    const prefix = lookupKey.split('.')[0]
    const scopes = Object.values(TARIFF_FEATURE_SCOPES)

    return scopes.includes(prefix) ? prefix : null
}

export function getDowngradePolicy(lookupKey) {
    return TARIFF_DOWNGRADE_POLICIES[lookupKey] || DEFAULT_TARIFF_DOWNGRADE_POLICY
}

export function isQuizOwnedFeatureKey(lookupKey) {
    return getFeatureScope(lookupKey) === TARIFF_FEATURE_SCOPES.QUIZ
}
